import { FC, JSX, useEffect, useState } from "react";
import "./ArticlesSubsectionsList.scss";
import MasterPage from "../../MasterPage/MasterPage";
import PageBase from "../../../components/PageBase/PageBase";
import SkeletonTable from "../../../components/SkeletonTable/SkeletonTable";
import AppPagination from "../../../components/AppPagination/AppPagination";
import { toast } from "react-toastify";
import DropdownMenuTable from "../../../components/DropdownMenuTable/DropdownMenuTable";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faEdit,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import { usePaginate } from "../../../providers/PaginateProvider";
import SidebarArticlesSubsectionsFilter from "../../../components/Articles/Subsections/SidebarArticlesSubsectionsFilter/SidebarArticlesSubsectionsFilter";
import ModalArticlesSubsectionsInsert from "../../../components/Articles/Subsections/ModalArticlesSubsectionsInsert/ModalArticlesSubsectionsInsert";
import { useSidebarFilter } from "../../../providers/SidebarFilterProvider";
import moment from "moment";
import { useSubsections } from "../../../providers/Articles/Subsections/SubsectionsProvider";
import { SubsectionModel } from "../../../models/Articles/Subsections/SubsectionModel";
import { useSections } from "../../../providers/Articles/Sections/SectionsProvider";
import ModalSortSubsectionsInsert from "../../../components/ModalSortSubsectionsInsert/ModalSortSubsectionsInsert";

interface ArticlesSubsectionsListProps {}

const ArticlesSubsectionsList: FC<ArticlesSubsectionsListProps> = () => {
  const [showModalInsert, setShowModalInsert] = useState<boolean>(false);
  const [showModalSortSubsectionsInsert, setShowModalSortSubsectionsInsert] =
    useState<boolean>(false);

  const { setParams: setParamsSections } = useSections();
  const {
    pages,
    params,
    setParams,
    isLoading,
    error,
    subsections,
    setSubsection,
    handleList,
    handleDelete,
    setIsLoading,
    handleReactivate,
  } = useSubsections();
  const { handlePaginate } = usePaginate();
  const { showSidebarFilter, setShowSidebarFilter } = useSidebarFilter();

  const handleEdit = (item: SubsectionModel) => {
    setSubsection(item);
    setShowModalInsert(true);
  };

  const handleReactivateItem = async (itemId: number) => {
    if (itemId <= 0) return;

    const ret = await handleReactivate(itemId);

    if (ret) {
      toast.success("Subseção reativada com sucesso!");
      handleList();
    }
  };

  const handleDeleteArticlesSubsectionsList = (item: SubsectionModel) => {
    Swal.fire({
      title: "<strong>Atenção?</strong>",
      html: `<span>Deseja excluir a subseção ${item?.name}?</span>`,
      icon: "question",
      confirmButtonText: "Sim, deletar!",
      cancelButtonText: "Cancelar",
      showCancelButton: true,
      confirmButtonColor: "var(--primary)",
    }).then(async (x: any) => {
      if (x.isConfirmed) {
        const ret = await handleDelete(item.id || 0).then();
        if (ret) {
          toast.success("Subseção de Artigos inativada com sucesso!");
          handleList();
        } else {
          await Swal.fire(
            "Ops!",
            `Não foi possível inativar a subseção.<br>${error}`,
            "error"
          );
        }
      }
    });
  };

  const renderList = (): JSX.Element => {
    return (
      <>
        {subsections?.length > 0 ? (
          <>
            {subsections.map((x: SubsectionModel, key: number) => (
              <tr key={x.id} className="text-sm">
                <td className="text-center">{x.id}</td>
                <td>{x?.name}</td>
                <td className="text-wrap description-cell">{x?.description}</td>
                <td>{x?.section?.name}</td>
                <td className="text-center">
                  <span
                    className={
                      x?.deleted_at ? "badge bg-danger" : "badge bg-success"
                    }
                  >
                    {x?.deleted_at ? "Inativo" : "Ativo"}
                  </span>
                </td>
                <td className="text-center">
                  {moment(x?.created_at).format("DD/MM/YYYY HH:mm:ss")}
                </td>
                <td className="text-center">
                  <DropdownMenuTable key={key}>
                    {!x?.deleted_at && (
                      <>
                        <Dropdown.Item
                          className="border-radius-md py-2"
                          onClick={() => handleEdit(x)}
                        >
                          <FontAwesomeIcon icon={faEdit} className="me-2" />{" "}
                          Editar
                        </Dropdown.Item>

                        <Dropdown.Item
                          className="border-radius-md py-2"
                          onClick={() => handleDeleteArticlesSubsectionsList(x)}
                        >
                          <FontAwesomeIcon icon={faTrash} className="me-2" />{" "}
                          Remover
                        </Dropdown.Item>
                      </>
                    )}
                    {x?.deleted_at && (
                      <Dropdown.Item
                        className="border-radius-md py-2"
                        onClick={() => handleReactivateItem(x?.id ?? 0)}
                      >
                        <FontAwesomeIcon
                          icon={faCircleCheck}
                          className="me-2"
                        />
                        Reativar
                      </Dropdown.Item>
                    )}
                  </DropdownMenuTable>
                </td>
              </tr>
            ))}
          </>
        ) : (
          <tr>
            <td colSpan={7} className="text-center text-sm">
              Não há registros
            </td>
          </tr>
        )}
      </>
    );
  };

  const renderContent = (): JSX.Element => {
    return (
      <>
        {!isLoading ? (
          <div>
            <div className="table-responsive">
              <table className="table table-flush m-0 w-100">
                <thead className="thead-light">
                  <tr>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      #
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Nome
                    </th>
                    <th className="text-uppercase opacity-7 w-25" scope="col">
                      Descrição
                    </th>
                    <th className="text-uppercase opacity-7" scope="col">
                      Seção
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Status
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Data de Cadastro
                    </th>
                    <th
                      className="text-uppercase opacity-7 text-center"
                      scope="col"
                    >
                      Ação
                    </th>
                  </tr>
                </thead>
                <tbody>{renderList()}</tbody>
              </table>
            </div>

            {subsections?.length > 0 && (
              <div>
                <nav aria-label="...">
                  <AppPagination
                    pages={pages}
                    handlePaginate={handlePaginate}
                    params={params}
                    setParams={setParams}
                    style={{ backgroundColor: "#fff" }}
                  />
                </nav>
              </div>
            )}
          </div>
        ) : (
          <SkeletonTable />
        )}
      </>
    );
  };

  useEffect(() => {
    !!showModalInsert &&
      setParamsSections({ withPaginate: false, filter: { only_active: true } });
  }, [showModalInsert]);

  useEffect(() => {
    setParams({ ...params, page: 1, filter: { only_active: false } });
  }, []);

  return (
    <MasterPage title="Subseções de Artigos" icon="fas fa-file" footerFixed>
      <div
        className="ArticlesSubsectionsList"
        data-testid="ArticlesSubsectionsList"
      >
        <PageBase
          title="Subseções de Artigos"
          subtitle="Gerenciamento de Subseções de Artigos."
          handleInsert={() => setShowModalInsert(true)}
          handleFilter={() =>
            !!showSidebarFilter
              ? setShowSidebarFilter(false)
              : setShowSidebarFilter(true)
          }
          error={error}
          children={renderContent()}
          renderBtnAux2={
            <div>
              <button
                type="button"
                className="btn btn-outline-primary text-primary btn-sm mb-0"
                onClick={() => setShowModalSortSubsectionsInsert(true)}
              >
                +&nbsp; Ordernar Subseções
              </button>
            </div>
          }
          hasFilter
        />

        <ModalArticlesSubsectionsInsert
          show={showModalInsert}
          onClose={() => setShowModalInsert(false)}
        />

        <ModalSortSubsectionsInsert
          show={showModalSortSubsectionsInsert}
          onClose={() => setShowModalSortSubsectionsInsert(false)}
        />
      </div>

      <SidebarArticlesSubsectionsFilter />
    </MasterPage>
  );
};

export default ArticlesSubsectionsList;
